import { render, staticRenderFns } from "./actionReport.vue?vue&type=template&id=2ff88959&scoped=true&"
import script from "./actionReport.vue?vue&type=script&lang=js&"
export * from "./actionReport.vue?vue&type=script&lang=js&"
import style0 from "./actionReport.vue?vue&type=style&index=0&id=2ff88959&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff88959",
  null
  
)

export default component.exports